<template>
    <div class="main-content">
        <img
            class="maintenance-img"
            :src="imcIcon404"
            alt="">
    </div>
</template>
<script>
import { imcIcon404 } from '@assets/js/res'

export default {
    name: 'Q404',
    data: () => ({
        imcIcon404: imcIcon404,
    }),

}
</script>
<style lang="scss" scoped>
    .main-content{
        text-align: center;
        position: absolute;
        width: 600px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        .maintenance-img{
            display: inline-block;
            width: 100%;
        }
        .maintenance-desc{
            margin-top: 20px;
            font-size: 16px;
            line-height: 28px;
            color: #333;
            font-weight: 500;
            .u-colorful{
                color: #FF7414;
            }
        }
    }
    .mobile, .ipad{
        .main-content{
            width: 90%;
            padding: 0 5%;
            .maintenance-desc{
                margin-top: 30px;
                font-size: 32px;
                line-height: 56px;
            }
        }

    }
</style>
